import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { getFileUrl } from "../../api";

function Image(props) {
  const { image, objectFit, ...rest } = props;

  const src = useMemo(
    () => (typeof image === "string" ? image : getFileUrl(image?.url)),
    [image],
  );

  const placeholderSrc = useMemo(
    () =>
      typeof image === "string"
        ? null
        : getFileUrl(image?.formats?.thumbnail?.url),
    [image],
  );

  return (
    <LazyLoadImage
      width="100%"
      height="100%"
      effect="blur"
      {...rest}
      style={{ objectFit, color: "gray" }}
      src={src}
      placeholderSrc={placeholderSrc}
    />
  );
}

Image.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  alt: PropTypes.string,
  objectFit: PropTypes.string,
};

Image.defaultProps = {
  image: null,
  alt: "image",
  objectFit: "contain",
};

export default Image;
